import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  // ", "\n\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  input[type=\"radio\"] {\n    opacity: 0;\n    position: fixed;\n    width: 0;\n  }\n  > div:first-of-type {\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    margin: 0.25em 1em 0.25em 0.25em;\n    border: 0.1em solid black;\n    border-radius: 0.5em;\n    background: #ffffff;\n    vertical-align: bottom;\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from "styled-components";
import { styled } from "@styles";
var inputStyle = css(_templateObject(), function (props) {
  return props.checked && "color: #21125E;";
}, function (props) {
  return props.checked && "\n    // > \n    // div:first-of-type {\n    //   border: 4px solid #ED1C24;\n    // }\n    div > span {\n      width: 1em;\n      height: 1em;\n      display: block;\n      position: relative;\n      right: 3px;\n      bottom: 1px;\n      border-radius: 0.5em;\n      background-color: #25d366;\n    }\n    > div > span::before {\n      content: \"\";\n      width: 2px;\n      height: 10px;\n      position: absolute;\n      top: 3px;\n      left: 9px;\n      transform: rotate(45deg);\n      background-color: white;\n    }\n    > div > span::after {\n      content: \"\";\n      width: 5px;\n      height: 2px;\n      position: absolute;\n      top: 10px;\n      left: 3px;\n      transform: rotate(45deg);\n      background-color: white;\n    }\n    ";
});
export var Input = styled.div(_templateObject2(), inputStyle);
export var LabeledInput = styled.label(_templateObject3(), inputStyle);